export interface LetterTourStep {
    id: string;
    title: string;
    body: string;
    /** Sélecteur CSS de l’élément à mettre en avant (vide = carte centrée) */
    target?: string;
}

/** Incrémentez la version pour reproposer le guide après une refonte */
export const LETTER_TOUR_STORAGE_KEY = 'fcv_letter_tour_v1_done';

export const LETTER_TOUR_STEPS: LetterTourStep[] = [
    {
        id: 'welcome',
        title: 'Bienvenue dans l’éditeur de lettre',
        body:
            'Ce guide explique chaque zone de l’interface : sections, modèle, aperçu, IA et commande. Vous pourrez le relancer à tout moment via le bouton Aide (?).',
    },
    {
        id: 'logo',
        title: 'Logo FlashCV',
        body:
            'Le logo en haut à gauche vous ramène à votre espace (choix CV / lettre). Enregistrez vos sections avant de quitter pour ne rien perdre.',
        target: '[data-tour="letter-logo"]',
    },
    {
        id: 'help',
        title: 'Bouton Aide',
        body:
            'Le bouton « ? » relance ce tutoriel. Utilisez-le dès que vous êtes perdu dans l’éditeur.',
        target: '[data-tour="letter-help"]',
    },
    {
        id: 'regen',
        title: 'Régénérer',
        body:
            'Relance la rédaction automatique à partir de vos réponses (secteur, poste, qualités…). Le texte actuel est remplacé : vous pourrez à nouveau le modifier section par section.',
        target: '[data-tour="letter-regen"]',
    },
    {
        id: 'order',
        title: 'Commander / Télécharger',
        body:
            'Même logique que pour le CV : d’abord « Commander » (paiement ou crédit), puis le bouton devient « Télécharger PDF ». Sans paiement validé, le PDF ne se génère pas (sauf mode test).',
        target: '[data-tour="letter-order"]',
    },
    {
        id: 'logout',
        title: 'Déconnexion',
        body:
            'Ferme votre session sur cet appareil. Vos lettres restent sauvegardées : reconnectez-vous pour les retrouver.',
        target: '[data-tour="letter-logout"]',
    },
    {
        id: 'answers',
        title: 'Modifier mes réponses',
        body:
            'Revient au questionnaire (expérience, secteur, poste, qualités…). Utile si l’IA doit repartir sur de meilleures infos — pensez ensuite à régénérer.',
        target: '[data-tour="letter-answers"]',
    },
    {
        id: 'sections',
        title: 'Liste des sections',
        body:
            'Chaque ligne est une partie de la lettre : objet, destinataire/service, formule, introduction, corps, invitation, conclusion, signature (texte + dessin). Cliquez pour l’éditer dans le panneau du milieu.',
        target: '[data-tour="letter-sections"]',
    },
    {
        id: 'template',
        title: 'Modèle et couleur',
        body:
            'Changez le design de la lettre (Classique, Corporate, Moderne, Élégance CI) et la couleur d’accent. L’aperçu à droite se met à jour immédiatement.',
        target: '[data-tour="letter-style"]',
    },
    {
        id: 'editor',
        title: 'Zone d’édition',
        body:
            'Modifiez librement le texte de la section active. Cliquez « Enregistrer la section » (ou quittez le champ) pour sauver. L’aperçu reflète vos changements.',
        target: '[data-tour="letter-editor"]',
    },
    {
        id: 'preview',
        title: 'Aperçu A4',
        body:
            'Vue réaliste de votre lettre au format page. Vérifiez toujours cette zone avant de commander : orthographe, mise en page et signature.',
        target: '[data-tour="letter-preview"]',
    },
    {
        id: 'report',
        title: 'Signaler un problème',
        body:
            'La bulle orange en bas à droite ouvre le support FlashCV (bug, paiement, question). Décrivez le souci : l’équipe peut vous répondre dans l’app.',
        target: '[data-tour="report"]',
    },
    {
        id: 'finish',
        title: 'Vous êtes prêt',
        body:
            'Récap : vérifiez / corrigez les sections → choisissez modèle & couleur → Commander → Télécharger PDF. Relancez Aide (?) à tout moment. Bonne candidature !',
        target: '[data-tour="letter-help"]',
    },
];
